export enum TabsKeys {
  PROCESSING_FACILITY = 'processing-facility',
  SUPPLIERS = 'suppliers',
}
export enum TabsLabels {
  PROCESSING_FACILITY = 'Processing Facility',
  SUPPLIERS = 'Suppliers',
}
export enum customPaginationProps {
  ITEM_RENDER = 'itemRender',
}

export enum ItemRenderTypes {
  JUMP_NEXT = 'jump-next',
  JUMP_PREV = 'jump-prev',
  PAGE = 'page',
  PREV = 'prev',
  NEXT = 'next',
}

export enum ItemRenderButtons {
  JUMP_NEXT = '...',
  JUMP_PREV = '&lt; &lt;',
  PAGE = 'page',
  NEXT = '&gt;',
  PREV = '&lt;',
}

export enum ButtonProps {
  NEW_SUPPLIER = 'New supplier',
  NEW_PROCESSING_FACILITY = 'New Processing Facility'
}

export enum SearchProps {
  PLACEHOLDER_STRING = 'Search',
  SEARCH_NAME = 'search',
  EMPTY_STRING = '',
}
export enum ValueChainPageProps {
  PAGE_TITLE = 'Value Chain',
}
